import React from "react";
import PropTypes from "prop-types";
import IconButton from "../IconButton/IconButton";
import ArrowBack24 from "../../icons/ArrowBack24";
import { useNavigate } from "react-router-dom";

import styles from "./panel-header.scss";

/**
 * PanelHeader component.
 * You can add Back button or right action buttons.
 * 
 * @component
 * @example
 * <PanelHeader title="Panel" back={true} />
 */
export default function PanelHeader(props) {
    const { after, back, backIcon, onBackClick, title, ...restProps } = props;
    let navigate = useNavigate();

    function handleClickBack() {
        if (typeof onBackClick === "function") {
            onBackClick();
        } else {
            navigate(-1);
        }
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.content}>
                {back === true &&
                    <div className={styles.back}>
                        <IconButton icon={backIcon || <ArrowBack24 />} onClick={handleClickBack} />
                    </div>
                }
                <div className={styles.title_container}>
                    <h2 className={styles.title}>{title}</h2>
                </div>
                {after !== undefined &&
                    <div className={styles.after}>
                        {after}
                    </div>
                }
            </div>
        </div>
    )
};

PanelHeader.propTypes = {
    /**
     * Title of panel header.
     */
    title: PropTypes.string,
    /**
     * Elements to display on the right side of header.
     */
    after: PropTypes.element,
    /**
     * Draw back button before header's title.
     */
    back: PropTypes.bool,
    /**
     * Back button event handler.
     */
    onBackClick: PropTypes.func,
    /**
     * Icon to place inside back button.
     * Arrow24 by default.
     */
    backIcon: PropTypes.element
};